import type { PlayEvent } from '@/api/types'

import { progress, SOURCE_LABELS, when } from './historyFormat'

/**
 * The listening-history list.
 *
 * Shared by the settings card, which shows a handful, and the full page, which
 * shows all of them. One row definition so the two cannot drift — the card is a
 * preview of the page, and it should look like one.
 */
export function HistoryRows({ events }: { events: PlayEvent[] }) {
  return (
    <ul className="divide-y divide-border">
      {events.map((event) => (
        <li key={event.id} className="flex items-baseline gap-3 px-3 py-2">
          {/* Everything that can be long lives on the left and truncates;
              everything short lives on the right and never does. Sharing one line
              meant a long artist name pushed out the half of the row carrying
              what you did not already know. */}
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-text">{event.track.title}</p>
            <p className="truncate text-xs text-text-muted">
              {event.track.artist_name}
              {SOURCE_LABELS[event.source] ? ` · ${SOURCE_LABELS[event.source]}` : ''}
            </p>
          </div>
          <div className="shrink-0 text-right text-xs whitespace-nowrap text-text-subtle">
            <p>{when(event.started_at)}</p>
            {/* Only unfinished listens say anything. "Finished" on almost every
                row would be noise; the exception is the informative one. */}
            {progress(event) ? <p className="mt-0.5">{progress(event)}</p> : null}
          </div>
        </li>
      ))}
    </ul>
  )
}
